module.exports = __webpack_public_path__ + "static/media/free-coffee-mobile-fr.0f30b5dc.jpg";